// React
import React, { useState, useEffect } from 'react';

// Prop types
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { withRoomContext } from '../../../RoomContext';
import * as settingsActions from '../../../actions/settingsActions';
import * as roomActions from '../../../actions/roomActions';
import HomeJoinDialog from './HomeJoinDialog';

// Mui styles
import { withStyles } from '@material-ui/core/styles';

// Mui core
import Box from '@material-ui/core/Box';

// ConfirmDialog
import ConfirmDialog from '../Common/ConfirmDialog';

import { ROOM_AFK, ROOM_OFFLINE, ROOM_ONLINE, ROOM_TALKING } from '../../../const';

const styles = () =>
	({
		root : {
			width           : '100%',
			height          : '100%',
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			borderRadius    : '20px',
			backgroundColor : '#e5e5e2',
			padding         : '1%'
		},
		wrapper : {
			width           : '100%',
			height          : '100%',
			backgroundColor : 'white',
			borderRadius    : '5px',
			boxShadow       : '3px 3px 10px #aaa',
			padding         : '3%',
			position        : 'relative'
		},
		tableBg : {
			display       : 'flex',
			position      : 'absolute',
			height        : '100%',
			width         : '100%',
			zIndex        : '0',
			pointerEvents : 'none',
			paddingRight  : 'calc(6% + 10px)',
			paddingBottom : '6%'
		},
		tableBgLine : {
			height      : '100%',
			borderRight : '1px solid #ccc'
		},
		tableHeader : {
			display : 'flex'
		},
		tableHeaderText : {
			fontSize      : '0.8rem',
			textAlign     : 'center',
			paddingBottom : '3rem',
			color         : '#999898'
		},
		tableData : {
			display      : 'flex',
			listStyle    : 'none',
			marginBottom : '0.8rem',
			position     : 'relative'
		},
		tableDataLine : {
			listStyle     : 'none',
			fontSize      : '0.8rem',
			textAlign     : 'center',
			paddingBottom : '1rem'
		},
		roomNo : {
			width : '8%'
		},
		roomNoTitle : {
			width : '11%'
		},
		roomNoData : {
			border       : 'none',
			borderRadius : '0.5rem',
			background   : '#999898',
			padding      : '1.2rem',
			color        : 'white',
			textAlign    : 'center'
		},
		tableDataValues : {
			display        : 'flex',
			alignItems     : 'center',
			zIndex         : 1,
			height         : '100%',
			justifyContent : 'flex-end'
		},
		tableDataValue : {
			color     : '#888',
			textAlign : 'center',
			fontSize  : '0.8rem'
		},
		roomName : {
			width : '25%'
		},
		roomNameContent : {
			width      : '27%',
			display    : 'flex',
			alignItems : 'center'
		},
		roomNameBg : {
			textAlign : 'left',
			margin    : '0 2rem'
		},
		roomPass : {
			width : '15%'
		},
		roomStatus : {
			width          : '15%',
			display        : 'flex',
			justifyContent : 'center'
		},
		roomUser : {
			width     : '20%',
			minHeight : '1.5rem'
		},
		roomAction : {
			width  : '14%',
			border : 'none'
		},
		itemCenter : {
			width          : '100%',
			height         : '100%',
			justifyContent : 'center',
			display        : 'flex',
			alignItems     : 'center'
		},
		roomContentBg : {
			border     : 'none',
			height     : '100%',
			background : 'rgba(0,0,0,0.1)'
		},
		roomBorderStart : {
			borderRadius : '0.5rem 0 0 0.5rem'
		},
		roomBorderEnd : {
			borderRadius : '0 0.5rem 0.5rem 0'
		},
		statusBg : {
			background   : '#999898',
			padding      : '0.2rem 0',
			borderRadius : '0.3rem',
			color        : 'white',
			width        : '90%'
		},
		statusBgWaiging : {
			background : '#9ec317'
		},
		statusBgTalking : {
			background : '#eb8000'
		},
		userBg : {
			background   : '#999898',
			padding      : '0.3rem 0.5rem',
			borderRadius : '0.3rem',
			color        : 'white',
			textAlign    : 'left',
			border       : 'none',
			'&:focus'    : {
				outline : 'none'
			}
		},
		actionBtn : {
			background   : 'white',
			border       : '1px solid #acacac',
			borderRadius : '0.3rem',
			color        : '#acacac',
			width        : '3rem',
			padding      : '0.1rem',
			fontSize     : '0.8rem',
			cursor       : 'pointer',
			'&:hover'    : {
				backgroundColor : '#c0d748',
				color           : 'white'
			}
		},
		scrollBar : {
			overflow               : 'auto',
			height                 : '100%',
			paddingRight           : '10px',
			'&::-webkit-scrollbar' :
			{
				background   : '#ccc',
				width        : '7px',
				borderRadius : '100px'
			},
			'&::-webkit-scrollbar-thumb' :
			{
				background   : '#888',
				borderRadius : '100px',
				'&:hover'    :
				{
					background : '#555'
				}
			}
		}
	});

const HomeJoinView = ({
	roomClient,
	classes,
	rooms,
	setHomeJoinDialogOpen,
	homeJoinDialogOpen
}) =>
{
	const [ roomList, setUserRoomList ] = useState([]);
	const [ roomContext, setRoomContext ] = useState(null);

	useEffect(() =>
	{
		setUserRoomList(rooms);
	}, [ rooms ]);

	useEffect(() =>
	{
		if (roomContext != null)
		{
			setHomeJoinDialogOpen(true);
		}
		else
		{
			setHomeJoinDialogOpen(false);
		}
	}, [ roomContext, setHomeJoinDialogOpen ]);

	useEffect(() =>
	{
		if (homeJoinDialogOpen === false)
		{
			setRoomContext(null);
		}
	}, [ homeJoinDialogOpen ]);

	const handleChangeRoomUser = (index, e) =>
	{
		roomList[index].user = e.target.value;
		setUserRoomList([ ...roomList ]);
	};

	const showDialog = (item) =>
	{
		setRoomContext(item);
	};

	return (
		<Box className={classes.root}>
			<Box className={classes.wrapper}>
				<Box className={classes.tableBg}>
					<Box className={`${classes.tableBgLine} ${classes.roomNoTitle}`} />
					<Box className={`${classes.tableBgLine} ${classes.roomName}`} />
					<Box className={`${classes.tableBgLine} ${classes.roomPass}`} />
					<Box className={`${classes.tableBgLine} ${classes.roomStatus}`} />
					<Box className={`${classes.tableBgLine} ${classes.roomUser}`} />
					<Box className={`${classes.tableBgLine} ${classes.roomAction}`} />
				</Box>
				<Box className={`${classes.scrollBar}`}>
					<ul>
						<Box className={classes.tableHeader}>
							<Box className={`${classes.tableHeaderText} ${classes.roomNoTitle}`}>
								ルームNo.
							</Box>
							<Box className={`${classes.tableHeaderText} ${classes.roomName}`}>
								ルーム名
							</Box>
							<Box className={`${classes.tableHeaderText} ${classes.roomPass}`}>
								PASS
							</Box>
							<Box className={`${classes.tableHeaderText} ${classes.roomStatus}`}>
								ステータス
							</Box>
							<Box className={`${classes.tableHeaderText} ${classes.roomUser}`}>
								利用者
							</Box>
							<Box className={`${classes.tableHeaderText} ${classes.roomAction}`}>
								入室
							</Box>
						</Box>
						{roomList.length < 1 ? (
							<Box>no items</Box>
						) : (
							roomList.map((item, index) =>
								(<li className={classes.tableData} key={index}>
									<Box className={`${classes.roomNo}`}>
										<Box className={classes.roomNoData}>room.{index + 1}</Box>
									</Box>
									<Box position='absolute' width='100%' height='100%'>
										<Box className={`${classes.tableDataValues}`}>
											<Box
												className={`${classes.tableDataValue} ${classes.roomNameContent} ${classes.roomContentBg} ${classes.roomBorderStart}`}
											>
												<Box className={classes.roomNameBg}>{item.name}</Box>
											</Box>
											<Box className={`${classes.roomPass} ${classes.roomContentBg}`}>
												<Box className={`${classes.tableDataValue} ${classes.itemCenter}`}>
													{ item.password ? 'あり' : 'なし' }
												</Box>
											</Box>
											<Box className={`${classes.roomStatus} ${classes.roomContentBg}`}>
												<Box className={`${classes.tableDataValue} ${classes.itemCenter}`}>
													{ item.status === ROOM_OFFLINE &&
														<Box className={classes.statusBg}>オフライン</Box>
													}
													{ item.status === ROOM_ONLINE &&
														<Box className={`${classes.statusBg} ${classes.statusBgWaiging}`}>待機中</Box>
													}
													{ item.status === ROOM_TALKING &&
														<Box className={`${classes.statusBg} ${classes.statusBgTalking}`}>通話中</Box>
													}
													{ item.status === ROOM_AFK &&
														<Box className={classes.statusBg}>離席中</Box>
													}
												</Box>
											</Box>
											<Box className={`${classes.roomUser} ${classes.roomContentBg}`}>
												<Box className={`${classes.tableDataValue} ${classes.itemCenter}`}>
													<input
														value={item.user}
														className={classes.userBg}
														onChange={(value) => handleChangeRoomUser(index, value)}
														type='text'
														disabled={1}
													/>
												</Box>
											</Box>
											<Box
												className={`${classes.roomAction} ${classes.roomContentBg} ${classes.roomBorderEnd}`}
											>
												<Box className={`${classes.tableDataValue} ${classes.itemCenter}`}>
													{ item.status === 0 &&
														<Box
															className={classes.actionBtn}
															onClick={() => showDialog(item)}
														>
															入室
														</Box>
													}
												</Box>
											</Box>
										</Box>
									</Box>
								</li>)
							))}
					</ul>
				</Box>
			</Box>
			{homeJoinDialogOpen === true &&
				<HomeJoinDialog roomClient={roomClient} roomContext={roomContext}/>
			}
		</Box>
	);

};

HomeJoinView.propTypes =
{
	roomClient            : PropTypes.any.isRequired,
	room                  : PropTypes.object.isRequired,
	setMediaPerms         : PropTypes.func.isRequired,
	classes               : PropTypes.object.isRequired,
	mediaPerms            : PropTypes.object.isRequired,
	setAudioMuted         : PropTypes.func.isRequired,
	setVideoMuted         : PropTypes.func.isRequired,
	rooms                 : PropTypes.array.isRequired,
	setHomeJoinDialogOpen : PropTypes.func.isRequired,
	homeJoinDialogOpen    : PropTypes.bool.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		room                  : state.room,
		mediaPerms            : state.settings.mediaPerms,
		displayName           : state.settings.displayName,
		displayNameInProgress : state.me.displayNameInProgress,
		loginEnabled          : state.me.loginEnabled,
		loggedIn              : state.me.loggedIn,
		locale                : state.intl.locale,
		localesList           : state.intl.list,
		rooms                 : state.me.rooms,
		homeJoinDialogOpen    : state.room.homeJoinDialogOpen
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		changeDisplayName : (displayName) =>
		{
			dispatch(settingsActions.setDisplayName(displayName));
		},
		setMediaPerms : (mediaPerms) =>
		{
			dispatch(settingsActions.setMediaPerms(mediaPerms));
		},
		setAudioMuted : (flag) =>
		{
			dispatch(settingsActions.setAudioMuted(flag));
		},
		setVideoMuted : (flag) =>
		{
			dispatch(settingsActions.setVideoMuted(flag));
		},
		setHomeJoinDialogOpen : (flag) =>
		{
			dispatch(roomActions.setHomeJoinDialogOpen(flag));
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.inLobby === next.room.inLobby &&
				prev.room.homeJoinDialogOpen === next.room.homeJoinDialogOpen &&
				prev.room.signInRequired === next.room.signInRequired &&
				prev.room.overRoomLimit === next.room.overRoomLimit &&
				prev.settings.displayName === next.settings.displayName &&
				prev.settings === next.settings &&
				prev.me.displayNameInProgress === next.me.displayNameInProgress &&
				prev.me.loginEnabled === next.me.loginEnabled &&
				prev.me.loggedIn === next.me.loggedIn &&
				prev.me.picture === next.me.picture &&
				prev.intl.locale === next.intl.locale &&
				prev.intl.localesList === next.intl.localesList &&
				prev.me.rooms === next.me.rooms
			);
		}
	}
)(withStyles(styles)(HomeJoinView)));
